/**
 * Import dependencies.
 */
import $ from 'jquery';
import 'slick-carousel';

function initCardSlider() {
  $('.dgd-card-slider').each(function () {
    const $this = $(this);
    const $items = $this.find('.dgd-card-slider__slides');

    $items.slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      speed: 300,
      accessibility: true,
      prevArrow: $this.find('.dgd-card-slider__arrow-left'),
      nextArrow: $this.find('.dgd-card-slider__arrow-right'),
      responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
    });
  });

}

window.addEventListener('DOMContentLoaded', initCardSlider);